export default __webpack_public_path__ + "static/media/640_private03-jp-web.87d3928c.png";